export default {
  driedCookingProcessChecks: [],
  driedCookingProcessCheck: undefined,
};
